var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wellcome"}},[_c('div',{staticStyle:{"font-size":"30px"}},[_vm._v("欢迎来到菲尔斯特！")])])
}]

export { render, staticRenderFns }